import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import useMediaQuery from '@mui/material/useMediaQuery'

import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'



const styles = {
  root: css`
    padding: 20px 30px;
    width: 100%;
    background-color: #000;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
  `,
  titleContainer: css`
    h3 {
      font-size: 1.1rem;
      font-weight: 500;
    }
  `,
  caption: css`
    font-size: 0.83rem;
    font-weight: 300;
  `,
  button: css`
    color: #fff;
  `
}


const FilterHeader = props => {

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))
  
  const {title, caption, clear, close} = props


  return (
    <div css={styles.root}>
      <div css={styles.titleContainer}>
        <h3>{title}</h3>

        {caption && <p css={styles.caption}>{caption}</p>}
      </div>

      <div>
        <Button css={styles.button} variant='text' onClick={clear}>
          CLEAR
        </Button>

        {isSmallScreen &&
          <IconButton css={styles.button} onClick={close}>
            <CloseIcon />
          </IconButton>
        }
      </div>
    </div>
  )
}


export default FilterHeader